import {SessionActions} from '../../data/Action';
import config from '../../config/config';

const SESSION_KEY = "pt.deliverytracker.key.session"


/**
 * Store Authentication information on the window object
 *
 * @param query
 */
function createSession(query) {
    var session = {};
    session['user'] = query.user;
    session['store_id'] = query.store_id;
    session['tS'] = query['tS'];
    session['ts'] = query['ts'];
    session['md5'] = query.md5;

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));

    SessionActions.createSession(session);

    return session;
}


function getSession() {


    // var session = {};

    let session = {};

    if (config.mock && config.mock === true) {
        console.debug("getSession: Using mock session")
        session['user'] = "Anomynous";
        session['store_id'] = 999;
        session['tS'] = 10000000000;
        session['ts'] = 10000000000;
        session['md5'] = "####################";

        return session;
    }


    let sessionStr = sessionStorage.getItem(SESSION_KEY);

    if (sessionStr) {
        session = JSON.parse(sessionStr);
    }

    return session;
}


function clearSession() {
    sessionStorage.clear();
    SessionActions.closeSession();
}

function getLoginUser() {
    var session = getSession();
    if (session !== undefined && session != null) {
        return session['user'];
    }
}


function getLoginStoreId() {
    var session = getSession();
    if (session !== undefined && session != null) {
        return session['store_id'];
    }
}

/**
 * Merge two array with no duplicated entries
 * @param update, entries in this array will be used in the case of equal entries
 * @param base, base or current array
 * @returns {Array} merged result of entries
 */
function mergeArraysDistinct(update, base) {
    if (!Array.isArray(update)) {
        return base;
    }

    update.sort((a, b) => {
        return a.id - b.id
    });

    base.sort((a, b) => {
        return a.id - b.id
    });

    let i0 = 0;
    let i1 = 0;


    var result = [];

    while (i0 < update.length || i1 < base.length) {
        let v0 = i0 < update.length ? update[i0].id : Number.MAX_VALUE;
        let v1 = i1 < base.length ? base[i1].id : Number.MAX_VALUE;
        if (v0 > v1) {
            result.push(base[i1]);
            i1++;
        } else {
            result.push(update[i0]);
            i0++;
            if (v0 === v1) {
                i1++;
            }
        }
    }

    return result;

}


const POSTAL_CODE_REGEX = new RegExp('([0-9]+(-[0-9]+){0,1}) ([A-Z -]+[A-Z])');
const ADDRESS_REGEX = new RegExp('([A-Z -]+ [0-9]+) ');

function trimOrderAddress(order) {
    let postalCode = order.postalCode;
    let address = order.address;

    let filteredAddress = address;
    let addressMatch = ADDRESS_REGEX.exec(address);

    if (addressMatch) {
        let matchAddress = addressMatch[1].trim();
        if (matchAddress.length > 12 && address.startsWith(matchAddress)) {
            filteredAddress = matchAddress;
        }
    }

    // If no filtered was done, try to remove postal code
    if (filteredAddress === address){
        let matchPostalCode = POSTAL_CODE_REGEX.exec(postalCode);
        if (matchPostalCode) {
            let postalAreaName = matchPostalCode[3];
            let index = address.lastIndexOf(postalAreaName);
            if (index > 0) {
                filteredAddress = address.substring(0, index).trim();
            }
        }
    }


    return filteredAddress;
}


export default {
    createSession,
    clearSession,
    getSession,
    getLoginUser,
    getLoginStoreId,
    mergeArraysDistinct,
    trimOrderAddress,
};


// WEBPACK FOOTER //
// ./src/script/utils/commons.js